import React, { FC, HTMLAttributes, memo } from "react";
import styled from "styled-components";

export type Props = HTMLAttributes<HTMLDivElement>;
const AmagamiText: FC<Props> = (...props) => {
  return(
    <Root {...props}>
      <Text>
        本協議会は、アニメコンテンツの力で銚子市を盛り上げていく組織・プロジェクトとして発足いたしました。<br />
        今年だけでなく長期に渡って、ファンの皆様が銚子市に愛着を持っていただき、楽しんでもらえるよう、活動していきます。<br />
        「ファンの皆様の声」を、銚子市アニメツーリズムの運営にしっかり反映していき、観光施策を実現してまいります。<br />
        ＜構成メンバー＞<br />
        　・銚子市（観光商工課観光プロモーション室）<br />
        　・一般社団法人銚子市観光協会<br />
        　・株式会社ベルパレット<br />
        　・一般社団法人アニメツーリズム協会<br />
        　・アニメファンド株式会社<br />
      </Text>
    </Root>
  )
};
export default memo(AmagamiText);

const Root = styled.div`
  border: 1px solid #fff;
  padding: 10px;
  color: white;
  line-height: 1.428em;
  @media screen and (max-width: 1280px) {
    font-size: 14px;
  }
  @media screen and (min-width: 1281px) {
    font-size: 16px;
  }
`;
const Text = styled.div`
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;
